import { useMemo } from 'react';

import dayjs, { Dayjs } from 'dayjs';

export default function useMarks(
  startDate: Dayjs | undefined = dayjs(),
  daysNumber: number | undefined = 5,
) {
  const today = startDate.set('hour', 0);
  const actualHour = startDate.hour();

  const allMarks = useMemo(() => {
    const hours: Dayjs[] = [];

    for (let i = 0; i < daysNumber; i += 1) {
      for (let j = 0; j < 24; j += 1) {
        const newHour = today.add(i, 'day').add(j, 'hour');
        hours.push(newHour);
      }
    }

    return hours.map((hour) => ({
      value: hour,
      label: <span />,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, actualHour]);

  return allMarks;
}
